// IMPORTED FROM WELLNESS
import { breakpoints } from '~/helpers/breakpoints';

// TODO: this is a V2 of useCurrentWindowSize, as the vueuse function
// currently has issues with SSR
// TO Delete useCurrentWindowSize when refacto
export interface UseScreen {
  isDesktop: ComputedRef<0 | boolean | undefined>;
  isMobile: ComputedRef<0 | boolean | undefined>;
  windowWidth: Ref<number | undefined>;
}

/**
 * @returns
 */
export function useScreen(): UseScreen {
  const windowWidth = ref<number>();

  const isMobile = computed(() => windowWidth.value && windowWidth.value <= breakpoints.md);

  const isDesktop = computed(() => {
    return windowWidth.value && windowWidth.value >= breakpoints.lg;
  });

  const handleResize = () => {
    windowWidth.value = window.innerWidth;
  };

  onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  return { isDesktop, isMobile, windowWidth };
}
